'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceImport;

var _getRegexMatchStr = require('./getRegexMatchStr');

var _getRegexMatchStr2 = _interopRequireDefault(_getRegexMatchStr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function replaceImport(code, oldSource, newSource) {
  var matchString = '';

  if (oldSource.match(/\*$/)) {
    matchString = '' + oldSource.replace(/\*$/, '()([^"\']*');
  } else {
    matchString = '(' + oldSource + ')(';
  }

  var regexMatchStr = (0, _getRegexMatchStr2.default)(matchString);

  var newRegex = new RegExp(regexMatchStr, 'g');
  // $1 and $3 capture groups are used for 'require' statements, while $4 and $6
  // are used for 'import' statements
  return code.replace(newRegex, '$1$4' + newSource + '$3$6');
}